import { useMutation } from "@tanstack/react-query";
import { useRequiredParams } from "../utils/url";
import { assetsApiRequest } from "../api/api-request";
import { Alarm, AlarmList } from "./alarm.model";

// Mutations

export function useUpdateAlarmMutation() {
  const { companyId } = useRequiredParams({ companyId: "number" });

  return useMutation({
    mutationFn: (alarm: Alarm) => updateAlarm({ companyId, alarm }),
  });
}

export function useUpdateAlarmsMutation() {
  const { companyId } = useRequiredParams({ companyId: "number" });

  return useMutation({
    mutationFn: (alarms: AlarmList[]) => updateAlarms({ companyId, alarms }),
  });
}

// Mutators

async function updateAlarm(params: {
  companyId: number;
  alarm: Alarm | AlarmList;
}) {
  const { id, value } = params.alarm;
  return assetsApiRequest
    .put(`analytics/companies/${params.companyId}/alarms/${id}`, {
      ...value,
    })
    .then((o) => o);
}

async function updateAlarms(params: {
  companyId: number;
  alarms: AlarmList[];
}) {
  const { alarms, companyId } = params;
  await Promise.all(
    alarms.map(async (a) => updateAlarm({ companyId, alarm: a })),
  );
}
